<template>
  <!--  form-section повешан, потому что companies-section используется еще в профиле, вне диалога -->
  <section class="form-section grid-block">
    <header> Юридические лица
      <VLink
        material="add"
        @click="createCompany"
      >
        Добавить юр лицо
      </VLink>
    </header>

    <div class="content">
      <VDataGridV2
        :data="companies"
        :context-menu="CompaniesService.getContextMenu(localPartner)"
        layout="fill"
        @row:dblclick="editCompany"
        @contextMenuItem:done="onContextMenuItemDone"
      >
        <VDataGridColumnV2
          id="name"
          label="Юр. лицо"
          width="250px"
          content-class="ellipsis nowrap"
        >
          <template #default="{ row }">
            <div
              class="ellipsis nowrap"
              :title="row.name"
            >
              {{ row.name }}
            </div>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="inn"
          label="ИНН"
          width="110px"
        >
          <template #default="{ row }">
            <template v-if="row.additionalAttributes?.inn">
              {{ row.additionalAttributes?.inn?.value }}
            </template>
            <template v-else>
              --
            </template>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="kpp"
          label="КПП"
          width="110px"
        >
          <template #default="{ row }">
            <template v-if="row.additionalAttributes?.kpp">
              {{ row.additionalAttributes?.kpp?.value }}
            </template>
            <template v-else>
              --
            </template>
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<script lang="ts">

import Partner          from '@/domains/Partners/Partner';
import Company          from '@/domains/Companies/Company';
import CompaniesService from "@/domains/Companies/CompaniesService";

export default defineComponent({
  name: 'CompaniesSection',

  props: {
    localPartner: {
      type:    Partner,
      default: null,
    },
  },

  /** Компании изменились — PartnerCard перечитает партнёра, грид обновится через :data */
  emits: [
    'companies:updated',
  ],

  setup() {
    return {
      CompaniesService,
    };
  },

  computed: {
    companies() {
      return this.localPartner.companies || [];
    },
  },

  methods: {
    async createCompany(): Promise<void> {
      if (await CompaniesService.showCompanyCard(null, this.localPartner) === true) {
        this.$emit('companies:updated');
      }
    },

    async editCompany(company: Company): Promise<void> {
      if (await CompaniesService.showCompanyCard(company, this.localPartner) === true) {
        this.$emit('companies:updated');
      }
    },

    /** Грид с :data сам не обновляется — по результату пункта меню перечитываем партнёра */
    onContextMenuItemDone(item: unknown, row: Company, result: boolean | void): void {
      if (result === true) {
        this.$emit('companies:updated');
      }
    },
  },
});
</script>